import { pb } from "lib/pocketbase";

async function getHeroBanner() {
  try {
    let response = await pb.collection("homepage_hero").getFullList({
      sort: "-created",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getServicesType() {
  try {
    let response = await pb.collection("service_type").getList(1, 4, {
      sort: "sort_order",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getTalents() {
  try {
    let response = await pb.collection("talent").getFullList({
      sort: "sort_order",
      filter: "homepage_highlighted = true",
      expand: "category",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getPortfolios() {
  try {
    let response = await pb.collection("portfolio").getList(1, 5, {
      sort: "sort_order",
      filter: "homepage_highlighted = true",
      expand: "service_type",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getClients(key_name = "") {
  try {
    let queryParams = {
      sort: "created",
      requestKey: null,
    };

    let filters = [];

    if (key_name) {
      filters.push(`name_key = "${key_name}"`);
    }

    if (filters.length > 0) {
      queryParams.filter = filters[0];
    }

    let response = await pb.collection("clients").getFullList(queryParams);

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

async function getFaq() {
  try {
    let response = await pb.collection("faq").getFullList({
      sort: "-sort_order",
    });

    return response;
  } catch (error) {
    console.log(error);
    return null; // Return empty on error
  }
}

export {
  getHeroBanner,
  getServicesType,
  getTalents,
  getPortfolios,
  getClients,
  getFaq,
};
